import React from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import { Add as AddIcon, Delete as DeleteIcon } from "@mui/icons-material";
import defaultNames from "src/utils/horseDefaultNames";
import { getUserPermissions } from "src/utils/permissionsUtils";

export default function GolfTeamNamesConfig({
  gameConfig,
  setGameConfig,
  loading,
}) {
  const { isViewer } = getUserPermissions();

  // Get current team names with fallback to default names
  const getCurrentNames = () => {
    if (gameConfig.teamNames && gameConfig.teamNames.length > 0) {
      return gameConfig.teamNames;
    } else {
      return Array(25).fill(null).map((_, index) => defaultNames[index] || "");
    }
  };

  const handleNameChange = (index, value) => {
    const currentNames = [...getCurrentNames()];
    currentNames[index] = value;

    setGameConfig({ ...gameConfig, teamNames: currentNames });
  };

  const handleAddTeamName = () => {
    const currentNames = getCurrentNames();
    const newNames = [...currentNames, ""];

    setGameConfig({ ...gameConfig, teamNames: newNames });
  };

  const handleDeleteTeamName = (index) => {
    const currentNames = getCurrentNames();
    if (currentNames.length <= 1) return;

    const newNames = currentNames.filter((_, i) => i !== index);

    setGameConfig({ ...gameConfig, teamNames: newNames });
  };

  return (
    <Box sx={{ mt: 2, p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Team Names Configuration
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        gutterBottom
        sx={{ mb: 3 }}
      >
        Configure the names for all teams in the golf game
      </Typography>

      <Grid container spacing={3}>
        {getCurrentNames().map((name, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={`name-${index}`}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <TextField
                fullWidth
                label={`Team ${index + 1}`}
                value={name}
                onChange={(e) => handleNameChange(index, e.target.value)}
                variant="outlined"
                disabled={loading}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#f8f9fa",
                    },
                    "&.Mui-focused": {
                      backgroundColor: "#ffffff",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#8e24aa",
                    fontWeight: 500,
                  },
                }}
              />
              {!isViewer && (
                <IconButton
                  onClick={() => handleDeleteTeamName(index)}
                  disabled={loading || getCurrentNames().length <= 1}
                  size="small"
                  sx={{
                    color:
                      getCurrentNames().length <= 1 ? "#ccc" : "#d32f2f",
                    "&:hover": {
                      backgroundColor:
                        getCurrentNames().length <= 1
                          ? "transparent"
                          : "#ffcdd2",
                    },
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddTeamName}
          disabled={loading}
          sx={{
            backgroundColor: "#8e24aa",
            "&:hover": {
              backgroundColor: "#7b1fa2",
            },
          }}
        >
          Add New Team Name
        </Button>
      </Box>
    </Box>
  );
}
